import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  countryList: [],
  countryDetail: [],
  countryFormList: [],
  countryFormDetail: [],
  loading: false,
  error: undefined,
};

const countrySlice = createSlice({
  name: "country",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    fetchCountryList(state, action) {
      state.countryList = action.payload;
      state.loading = false;
    },
    fetchCountryDetail(state, action) {
      state.countryDetail = action.payload;
      state.loading = false;
    },
    fetchCountryFormList(state, action) {
      state.countryFormList = action.payload;
      state.loading = false;
    },
    fetchCountryFormDetail(state, action) {
      state.countryFormDetail = action.payload;
      state.loading = false;
    },
  },
});

export const countryActions = countrySlice.actions;

export default countrySlice.reducer;
